import { FC } from 'react';
import { api, useApi } from '../api/api';
import IOApiTable from '../components/IOApiTable';
import { Container } from 'semantic-ui-react';
import { TextCell, Cell } from '../components/Table';


const UnsupportedLibs: FC<{}> = () => {
    const missingSources = useApi(api.missingSources);

    const text = (key: string, header?: string) => (
        <TextCell header={header ?? key} value={x => x[key]} />
    );

    const link = (key: string, header?: string) => (
        <Cell header={header ?? key} value={x => x[key]}
            render={x => <a href={x}>{x}</a>}
        />
    );

    return (
        <Container>
            <IOApiTable api={missingSources} fixed>
                {text('source')}
                {text('lastmodified', 'last modified')}
                {link('webaddress', 'url')}
                {text('sourcereference', 'source ref')}
            </IOApiTable>
        </Container>
    );
}


export default UnsupportedLibs;